/**
 * Lưu kết quả đăng nhập vào localStorage.
 *
 * Gom một chỗ vì giờ có bốn đường tới cùng một việc này (mật khẩu, Google đã có
 * tài khoản, Google vừa đăng ký xong, và sau khi đặt lại mật khẩu) - mỗi màn tự
 * làm một kiểu là có màn quên lưu refreshToken, rồi phiên hết hạn sau một tiếng
 * mà không ai hiểu tại sao.
 *
 * Backend bọc thân trả về trong { data }, nhưng không phải endpoint nào cũng
 * bọc, nên bóc cả hai dạng.
 */
export interface PhienDangNhap {
  token: string;
  refreshToken?: string;
}

export const bocThanTraVe = (rsp: any): any => (rsp && rsp.data ? rsp.data : rsp);

/**
 * Trả về true nếu thật sự có token để lưu. False nghĩa là máy chủ trả 2xx nhưng
 * không kèm token - gọi là thất bại, đừng điều hướng người dùng vào trang trong
 * rồi để họ gặp 401 ở mọi lời gọi tiếp theo.
 */
export const luuPhienDangNhap = (rsp: any): boolean => {
  const than = bocThanTraVe(rsp);
  if (!than?.token) {
    return false;
  }

  localStorage.setItem("token", than.token);
  if (than.refreshToken) {
    localStorage.setItem("refreshToken", than.refreshToken);
  }

  return true;
};
